import { render, staticRenderFns } from "./CmgButton.vue?vue&type=template&id=f07f609c&scoped=true&lang=pug"
import script from "./cmg-button.ts?vue&type=script&lang=ts&external"
export * from "./cmg-button.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgButton.vue?vue&type=style&index=0&id=f07f609c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07f609c",
  null
  
)

export default component.exports